import React from 'react';

import { PrismicRichText } from 'types/prismicRichtext';

import { RichText } from 'components/rich-text/RichText';
import { OneColumn, Content } from 'components/one-column/OneColumn';

interface IOneColumnContainer {
  text: PrismicRichText;
  isColumnLayout: boolean;
}

export const OneColumnContainer = ({ text, isColumnLayout }: IOneColumnContainer) => {
  return (
    <OneColumn isColumnLayout={isColumnLayout}>
      <Content>
        <RichText>{text}</RichText>
      </Content>
    </OneColumn>
  );
};
